import React, { useState, useEffect } from 'react';
import './StartMeeting.scss';
import Modal from '../Modal/Modal';
import Button from '../../../partials/Button';
import Participant from '../../../partials/Participant/Participant';
// import { first } from 'cheerio/lib/api/traversing';

const radiansPerDegree = 0.017453292519943295;
const circleDimensions = [500, 140];
const numberOfPaddingChairs = 2.5;

const StartMeeting = props => {

    const projectTeamMembers = props.data.teams
        .filter((team) => team.teamName === 'Project')
        .flatMap((team) => team.members);
    const otherTeamMembers = props.data.teams
        .filter((team) => team.teamName !== 'Project')
        .flatMap((team) => team.members);
    const [personModal, setPersonModal] = useState(null);
    const [showPresentationIntro, setShowPresentationIntro] = useState(false);
    const [presentationIntroPhase, setPresentationIntroPhase] = useState('speaker')
    const [presentationIntro, setPresentationIntro] = useState(props.intro[presentationIntroPhase])

    console.log('Start meeting props: ', props)

    function handlePersonClick(person) {
        setPersonModal({
            ...props.people[person], 
            isYou: person === props.teamMemberKey 
        });
        props.setPeople(() => {
            let temp  = {...props.people};
            temp[person].visited = true;
            return temp;
        });
    }

    function handleNext() {
        if (presentationIntroPhase === 'speaker') {
            setPresentationIntroPhase('user');
        } else {
            props.startMeeting();
        }
    }

    useEffect(() => {
        setPresentationIntro(props.intro[presentationIntroPhase])
    }, [presentationIntroPhase, props.intro])

    return (
        <>
            <div className={`start-meeting ${personModal ? `blur` : `` }`}>
                <div className='dialogue-box'>
                    {!showPresentationIntro ?

                    <div 
                        className="instructions" 
                        dangerouslySetInnerHTML={{__html: props.defaultInstructions}} 
                    />

                    :

                    <div 
                        className="presentation-intro"
                    >
                        <Participant
                            data={props.data}
                            hasNameTag={true}
                            isYou={presentationIntroPhase === 'user'}
                            teamMember={props.people[presentationIntro.person]}
                            size={'medium'}
                            hasVisited={false}
                            showDialog={false}
                        />
                        <div 
                            className='intro-text' 
                            dangerouslySetInnerHTML={{__html: presentationIntro.content}} />
                    </div>}

                </div>

                <div className='project-team'>
                        {/* as far as we know there is one overall team lead and a stakeholder */}
                        {projectTeamMembers.map((person, index) => {
                            // team members are numbered from zero to projectTeamMembers.length-1
                            // there are (projectTeamMembers.length - 1) + numberOfPaddingChairs*2 chairs in the 180° arc across one side of the table.
                            // the 0th team-member is offset from the begging of the arc by numberOfPaddingChairs.
                            const angle = ((index + numberOfPaddingChairs) /( (projectTeamMembers.length - 1) + numberOfPaddingChairs*2)) * 180 * radiansPerDegree;
                            return (<div 
                                className="team-member" 
                                key={person} 
                                id={person} 
                                // onClick={() => handlePersonClick(person)}
                                style={{
                                    top: `${(1 - Math.sin(angle)) * circleDimensions[1]}px`,
                                    left: `${Math.cos(angle) * circleDimensions[0]}px`
                                }}
                            >
                                <Participant
                                    key={person}
                                    data={props.data}
                                    hasNameTag={false}
                                    isYou={person === props.teamMemberKey}
                                    image={props.people[person].icon}
                                    size={'medium'}
                                    hasVisited={true}
                                    visited={props.people[person].visited}
                                    active={''}
                                    scale={0}
                                    showDialog={false}
                                    onClick={() => handlePersonClick(person)}
                                />
                            </div>);
                            })
                        }
                    </div>

                <div className='sub-team'>
                        {/* map through list of different sub teams */}
                        {/* for each sub team, render person icon */}
                        {/* in JSON, each sub team has:
                                -team name
                                -icon color
                                -lead name */}
                        {otherTeamMembers.map((person, index) =>  {
                            const angle = ((index + numberOfPaddingChairs) /( (otherTeamMembers.length - 1) + numberOfPaddingChairs*2)) * 180 * radiansPerDegree;
                            return (<div 
                                className="team-member" 
                                key={person} 
                                id={person}
                                // onClick={() => handlePersonClick(person)}
                                style={{
                                    top: `${(Math.sin(angle)) * circleDimensions[1]}px`,
                                    left: `${Math.cos(angle) * circleDimensions[0]}px`
                                }} 
                            > 
                        {/* TODO: Make user image color change with team */}
                                <Participant
                                    key={person}
                                    data={props.data}
                                    hasNameTag={false}
                                    isYou={person === props.teamMemberKey}
                                    image={props.people[person].icon}
                                    size={'medium'}
                                    hasVisited={true}
                                    visited={props.people[person].visited}
                                    active={''}
                                    scale={0}
                                    showDialog={false}
                                    onClick={() => handlePersonClick(person)}
                                />
                            </div>);
                        })}
                    </div>

                <div className='button-container'>

                        {!showPresentationIntro 
                            ?
                                <Button 
                                    className="start-meeting-btn" 
                                    onClick={() => setShowPresentationIntro(true)} 
                                    alt="Start Meeting" 
                                    text="Start Meeting"
                                />
                            :
                                <Button 
                                    className="next-btn" 
                                    // onClick={props.startMeeting} 
                                    onClick={handleNext} 
                                    alt="Next" 
                                    text="Next"
                                />
                        }
                    </div>

                <div className='table'>
                        <img 
                            src={'media/img/table.svg'} 
                            alt={``}
                        />
                    </div>
            </div>

            {personModal && <Modal>
                {console.log('personModal :', personModal)}
                <div className='main-container'>
                    <img 
                        className='person-icon' 
                        src={personModal.isYou ? 'media/img/icons/user-shape.svg' : personModal.icon} 
                        alt={personModal.isYou ? 'You' : `${personModal.first} ${personModal.last}`} 
                    />
                    <div className='profile-container'>
                        <h1 className='title'>
                            {personModal.isYou ? `You` : `${personModal.first} ${personModal.last}`} {` - ${personModal.title}`}
                        </h1>
                        <p className='description'>
                            {personModal.description}
                        </p>
                    </div>
                </div>
                <div className='btn-container'>
                    <Button className='close-button' onClick={() => setPersonModal(null)} alt='close' text="Close" />
                </div>
            </Modal>}
            
        </>
    )
}

export default StartMeeting;